import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BookOutlinedSvg from "@ant-design/icons-svg/es/asn/BookOutlined";
import AntdIcon from '../components/AntdIcon';
var BookOutlined = function BookOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: BookOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(BookOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BookOutlined';
}
export default RefIcon;